import { render, staticRenderFns } from "./stepFour.vue?vue&type=template&id=643233fb&lang=pug&"
import script from "./stepFour.vue?vue&type=script&setup=true&lang=js&"
export * from "./stepFour.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports